import { render, staticRenderFns } from "./consulehistory.vue?vue&type=template&id=68bce0ee&scoped=true"
import script from "./consulehistory.vue?vue&type=script&lang=js"
export * from "./consulehistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bce0ee",
  null
  
)

export default component.exports